"use client";

import React, { useState, useEffect, useRef, useCallback } from "react";
import fs from "fs/promises";
import path from "path";
import { z } from "zod";
import { HeaderSection } from "@/components/shared/header-section";
import { PageContainer } from "@/components/shared/page-container";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { DataTableManual } from "../../components/shared/data-table-manual/data-table-manual";
import { columns } from "./components/columns";

import { DataTableToolbar } from "../../components/shared/data-table-manual/data-table-toolbar-manual";
import { DrawerTrigger } from "@/components/ui/drawer";
import { SheetTrigger } from "@/components/ui/sheet";
import { useDrawerDispatch } from "@/context/DrawerContext";
import { Button } from "@/components/ui/button";
import FabricForm from "./FabricForm";
import { DELETE_MANY_FABRICS, GET_FABRIC_GROUPS } from "./fabricQueries";
import useOpenDrawer from "@/hooks/useOpenDrawer";
import { GET_FABRIC_TYPES } from "@/components/shared/inputComponents/FabricTypeSelect";
import { useDeleteConfirmation } from "@/hooks/useDeleteConfirmation";
import { PageContent } from "@/components/shared/page-content";
import { getOrderSortParams } from "@/utils/orderUtils";

export default function B2BCustomersTable() {
  const {
    data: { __type: { enumValues: fabricTypes } } = { __type: {} },
    error: er2,
  } = useQuery(GET_FABRIC_TYPES);

  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [tableDataCount, setTableDataCount] = useState(0);
  const [order, setOrder] = useState([]);
  const [filters, setFilters] = React.useState<Map<string, Set<string>>>(
    new Map()
  );

  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const [loadFabricGroups, { data, error, loading }] = useLazyQuery(
    GET_FABRIC_GROUPS,
    {
      variables: {},
      fetchPolicy: "cache-and-network",
    }
  );

  const { onDelete } = useDeleteConfirmation({
    mutation: DELETE_MANY_FABRICS,
    refetchQueries: ["GET_FABRIC_GROUPS"],
    messages: {
      success: "Fabric groups deleted successfully",
      error: "Failed to delete fabric groups",
    },
    itemName: "fabric group",
  });

  // Prepare filters and graphQL params to query data
  useEffect(() => {
    const queryFilter = Array.from(filters.entries())
      .map(([key, value]) => {
        if (!value.size) return null;
        return {
          [key]: {
            in: Array.from(value),
          },
        };
      })
      .filter(Boolean);

    console.log("queryFilter", queryFilter);

    loadFabricGroups({
      variables: {
        searchTerm,
        take: pagination.pageSize,
        skip: pagination.pageIndex * pagination.pageSize,
        filters: queryFilter,
        orderBy: getOrderSortParams(order),
      },
    });
  }, [searchTerm, pagination, order, filters]);

  useEffect(() => {
    setPagination({ ...pagination, pageIndex: 0 });
  }, [searchTerm, pagination.pageSize, order]);

  useEffect(() => {
    console.log("data useeffect", data);
    if (data) {
      const dataParsed = data.findManyFabricGroup.map((item: any) => {
        return {
          ...item,
          name: item.fabric_group_profiles[0]?.name,
        };
      });

      setTableData(dataParsed);
      setTableDataCount(data.findManyFabricGroupCount ?? 0);
    }
  }, [data]);

  const openabricForm = useOpenDrawer(FabricForm);

  return (
    <PageContent>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <HeaderSection title="Fabric Groups" />
        <Button onClick={openabricForm}>Create New +</Button>
      </div>
      {/* <SheetTrigger>Open</SheetTrigger> */}

      <DataTableManual
        data={tableData}
        columns={columns}
        rowCount={tableDataCount}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        onPaginationChange={setPagination}
        onSortingChange={setOrder}
        onColumnFiltersChange={setFilters}
        onRowClick={openabricForm}
        isLoading={loading}
        toolbar={(table: any) => (
          <DataTableToolbar
            table={table}
            config={{
              onDelete: onDelete,
              search: {
                placeholder: "Filter fabrics...",
                accessor: "name",
                onSearch: setSearchTerm,
                onFilter: setFilters,
              },
              columns: [
                {
                  title: "Fabric Type",
                  accessor: "type",
                  options: fabricTypes?.map((group: any) => ({
                    label: group.name,
                    value: group.name,
                  })),
                },
                // {
                //   title: "Price List",
                //   accessor: "price_listId",
                //   options: priceLists?.map((group: any) => ({
                //     label: group.name,
                //     value: group.id,
                //   })),
                // },
              ],
            }}
          />
        )}
      />
    </PageContent>
  );
}
